import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>Sanjaykumar49319@gmail.com</span>
        <div className="f-icons">
          <td
            onClick={() =>
              window.open(
                "https://www.facebook.com/sanjaykumar.sanjaykumar.7547",
                "_blank"
              )
            }
          >
            <Facebook color="blue" size={"3rem"} />
          </td>
          <td
            onClick={() =>
              window.open(
                "https://instagram.com/messsanjay?igshid=YmMyMTA2M2Y="
              )
            }
          >
            <Insta color="red" size={"3rem"} />
          </td>
          <td
            onClick={() =>
              window.open("https://github.com/sanjay91223", "_blank")
            }
          >
            <Gitub color="purple" size={"3rem"} />
          </td>
        </div>
      </div>
    </div>
  );
};

export default Footer;
